// extracted by mini-css-extract-plugin
module.exports = {"list":"notify_list__10gr_","item":"notify_item__2PAnH","overlay":"notify_overlay__1-Pyi","img":"notify_img__1YO6m"};